var LabelSelectorModule = /** @class */ (function () {
    function LabelSelectorModule() {
    }
    return LabelSelectorModule;
}());
export { LabelSelectorModule };
